export const menuCodes = [
    "dashboard",
    "devices",
    "alarms",
    "personnel",
    "audit",
    "exports",
    "system_settings",
    "settings",
    "mqtt_gateway",
    "modbus_gateway",
    "raw_protocol",
];
export const systemSettingsMenuCodes = [
    "settings",
    "mqtt_gateway",
    "modbus_gateway",
    "raw_protocol",
];
export function normalizeMenuKeys(keys) {
    const selected = new Set(keys);
    if (systemSettingsMenuCodes.some((key) => selected.has(key))) {
        selected.add("system_settings");
    }
    return menuCodes.filter((key) => selected.has(key));
}
export const menuTree = [
    { key: "dashboard", label: "运行总览" },
    { key: "devices", label: "设备管理" },
    { key: "alarms", label: "告警中心" },
    { key: "personnel", label: "人员管理" },
    { key: "audit", label: "审计日志" },
    { key: "exports", label: "导出任务" },
    {
        key: "system_settings",
        label: "系统设置",
        children: [
            { key: "settings", label: "参数配置" },
            { key: "mqtt_gateway", label: "MQTT 网关" },
            { key: "modbus_gateway", label: "Modbus 网关" },
            { key: "raw_protocol", label: "原始协议" },
        ],
    },
];
export const connectionStates = ["never_connected", "online", "offline", "unknown"];
export const dataStates = ["normal", "delayed", "interrupted", "unknown"];
export const alarmStatuses = ["open", "processing", "recovered", "closed"];
export const alarmKinds = [
    "over_voltage",
    "under_voltage",
    "over_current",
    "phase_loss",
    "frequency_out_of_range",
    "data_interrupted",
    "offline",
    "phase_imbalance",
];
export const messageStatuses = ["received", "processed", "failed", "duplicate"];
export const exportStatuses = ["pending", "processing", "completed", "failed", "expired"];
export const qualityCodes = ["good", "partial", "stale", "time_invalid", "out_of_range"];
//# sourceMappingURL=enums.js.map